export const API_GET_ALL_CANCEL_REASON_UNTAKEN = "API_GET_ALL_CANCEL_REASON_UNTAKEN";
export const API_GET_ALL_CANCEL_REASON_UNTAKEN_SUCCESS = "API_GET_ALL_CANCEL_REASON_UNTAKEN_SUCCESS";
export const API_GET_ALL_CANCEL_REASON_UNTAKEN_FAIL = "API_GET_ALL_CANCEL_REASON_UNTAKEN_FAIL";

export const API_GET_ALL_CANCEL_REASON_ADDED = "API_GET_ALL_CANCEL_REASON_ADDED";
export const API_GET_ALL_CANCEL_REASON_ADDED_SUCCESS = "API_GET_ALL_CANCEL_REASON_ADDED_SUCCESS";
export const API_GET_ALL_CANCEL_REASON_ADDED_FAIL = "API_GET_ALL_CANCEL_REASON_ADDED_FAIL";

export const API_GET_ALL_CANCEL_REASON_NATURE = "API_GET_ALL_CANCEL_REASON_NATURE";
export const API_GET_ALL_CANCEL_REASON_NATURE_SUCCESS = "API_GET_ALL_CANCEL_REASON_NATURE_SUCCESS";
export const API_GET_ALL_CANCEL_REASON_NATURE_FAIL = "API_GET_ALL_CANCEL_REASON_NATURE_FAIL";

export const API_ADMIN_GET_ALL_CANCEL_REASON = "API_ADMIN_GET_ALL_CANCEL_REASON";
export const API_ADMIN_GET_ALL_CANCEL_REASON_SUCCESS = "API_ADMIN_GET_ALL_CANCEL_REASON_SUCCESS";
export const API_ADMIN_GET_ALL_CANCEL_REASON_FAIL = "API_ADMIN_GET_ALL_CANCEL_REASON_FAIL";

export const API_ADMIN_GET_CANCEL_REASON = "API_ADMIN_GET_CANCEL_REASON";
export const API_ADMIN_GET_CANCEL_REASON_SUCCESS = "API_ADMIN_GET_CANCEL_REASON_SUCCESS";
export const API_ADMIN_GET_CANCEL_REASON_FAIL = "API_ADMIN_GET_CANCEL_REASON_FAIL";

export const API_ADMIN_POST_CANCEL_REASON = "API_ADMIN_POST_CANCEL_REASON";
export const API_ADMIN_POST_CANCEL_REASON_SUCCESS = "API_ADMIN_POST_CANCEL_REASON_SUCCESS";
export const API_ADMIN_POST_CANCEL_REASON_FAIL = "API_ADMIN_POST_CANCEL_REASON_FAIL";

export const API_ADMIN_PATCH_CANCEL_REASON = "API_ADMIN_PATCH_CANCEL_REASON";
export const API_ADMIN_PATCH_CANCEL_REASON_SUCCESS = "API_ADMIN_PATCH_CANCEL_REASON_SUCCESS";
export const API_ADMIN_PATCH_CANCEL_REASON_FAIL = "API_ADMIN_PATCH_CANCEL_REASON_FAIL";

export const API_ADMIN_DELETE_CANCEL_REASON = "API_ADMIN_DELETE_CANCEL_REASON";
export const API_ADMIN_DELETE_CANCEL_REASON_SUCCESS = "API_ADMIN_DELETE_CANCEL_REASON_SUCCESS";
export const API_ADMIN_DELETE_CANCEL_REASON_FAIL = "API_ADMIN_DELETE_CANCEL_REASON_FAIL";

export const API_ADMIN_GET_CANCEL_REASON_GROUPS = "API_ADMIN_GET_CANCEL_REASON_GROUPS";
export const API_ADMIN_GET_CANCEL_REASON_GROUPS_SUCCESS = "API_ADMIN_GET_CANCEL_REASON_GROUPS_SUCCESS";
export const API_ADMIN_GET_CANCEL_REASON_GROUPS_FAIL = "API_ADMIN_GET_CANCEL_REASON_GROUPS_FAIL";

export const ADMIN_INIT_NEW_CANCEL_REASON = "ADMIN_INIT_NEW_CANCEL_REASON";

export const ADMIN_RESET_FOCUS_CANCEL_REASON = "ADMIN_RESET_FOCUS_CANCEL_REASON";
